module.exports = __webpack_public_path__ + "296c4d305d8f6e9c42cb31299f00ba5f.svg";